import {Controller} from "stimulus"
import AutoNumeric from "autonumeric"
import {validateFields, formSubmittable} from "../../../lib/assets/form-validation";
import SlimSelect from "slim-select";
import Rails from "@rails/ujs";
import {openInspectionsMessage} from "./helpers/open_inspections_message";
import {outstandingTasksMessage} from "./helpers/outstanding_tasks_message";

export default class extends Controller {
    static targets = ["parcelSearchPanel", "addParcelText", "parcelCount", "openInspections", "originalCompletedOn", "openTasks", "originalApprovedOn"];

    connect() {
        console.log("log from permitting-application controller");
        if (document.querySelector(".permitting-form") != null) {
            formSubmittable(document.querySelector(".permitting-form"));
        }
        if (document.querySelector(".application-parcels") != null) {
            Array.from(document.querySelector(".application-parcels").querySelectorAll(".delete-action")).map(action => {
                action.classList.remove("hidden");
            });
        }
        this.updateParcelCount();
        this.attachAlternateSelectors();

    }

    updateFormFields(e) {
        const form = e.target.closest('form');
        const appTemplateId = e.target.value
        const fieldList = form.querySelector(".field-scope");
        let link = 'update_fields?permitting_app_template_id=' + appTemplateId
        if (window.location.pathname.includes("add_child")) {
            link = '/permitting/applications/new/update_fields?permitting_app_template_id=' + appTemplateId
        }
        link += "&field_scope=" + fieldList.value;
        console.log("updating form to app Template" + appTemplateId)
        fetch(link)
            .then(response => {
                return response.text();
            })
            .then(html => {
                document.getElementById("template-specific-fields").innerHTML = html;
            })
        validatePermittingForm(form)
    }


    validateForm(e) {
        const form = e.target.closest('form');
        validatePermittingForm(form)
    }

    confirmSubmit(e) {
        this.confirmWithoutParcel(e);
        if (e.defaultPrevented) return;
        this.confirmWithOutstandingTasks(e);
        if (e.defaultPrevented) return;
        this.confirmWithOpenInspections(e);
    }

    confirmWithoutParcel(e) {
        const parcelSummaryArea = document.querySelector(".application-parcels")?.querySelector("ul");
        const parcelCount = parcelSummaryArea ? parcelSummaryArea.querySelectorAll("li").length : 0;
        if (parcelCount === 0) {
            const proceed = window.confirm("This application has no parcels. Continue saving without a parcel?");
            if (!proceed) {
                e.preventDefault();
                e.stopPropagation();
            }
        }
    }

    confirmWithOutstandingTasks(e) {
        if (!this.hasOpenTasksTarget || !this.hasOriginalApprovedOnTarget) return;

        const alreadyApproved = this.originalApprovedOnTarget.value !== '';
        if (alreadyApproved) return;

        const approvedOnField = this.element.querySelector('[name="permitting_application[approved_on]"]');
        if (!approvedOnField || !approvedOnField.value) return;

        const openTasks = JSON.parse(this.openTasksTarget.value || '[]');
        if (openTasks.length === 0) return;

        if (!window.confirm(outstandingTasksMessage(openTasks))) {
            e.preventDefault();
            e.stopPropagation();
        }
    }

    confirmWithOpenInspections(e) {
        if (!this.hasOpenInspectionsTarget || !this.hasOriginalCompletedOnTarget) return;

        const alreadyCompleted = this.originalCompletedOnTarget.value !== '';
        if (alreadyCompleted) return;

        const completedOnField = this.element.querySelector('[name="permitting_application[completed_on]"]');
        if (!completedOnField || !completedOnField.value) return;

        const openInspections = JSON.parse(this.openInspectionsTarget.value || '[]');
        if (openInspections.length === 0) return;

        if (!window.confirm(openInspectionsMessage(openInspections))) {
            e.preventDefault();
            e.stopPropagation();
        }
    }

    toggleParcelSearch(e) {
        e.preventDefault();
        if (!this.hasParcelSearchPanelTarget) { return; }
        const hasParcels = this.currentParcelCount() > 0;
        if (this.parcelSearchPanelTarget.classList.contains("hidden")) {
            this.parcelSearchPanelTarget.classList.remove("hidden");
            return;
        }
        if (hasParcels) {
            this.parcelSearchPanelTarget.classList.add("hidden");
        }
    }

    updateSelectedParcels(e) {
        if (!(e.target.closest('li').classList.contains('selected'))) {
            const chosenParcel = e.currentTarget;
            if (!chosenParcel.dataset.assignmentKey) {
                return;
            }
            console.log('updating selected parcels!')
            const parcelSummaryArea = document.querySelector(".application-parcels").querySelector("ul");

            e.currentTarget.querySelector(".delete-action").classList.remove("hidden");
            chosenParcel.classList.add('selected');
            parcelSummaryArea.appendChild(chosenParcel);
            if (this.hasParcelSearchPanelTarget) {
                this.parcelSearchPanelTarget.classList.add("hidden");
            }
            if (this.hasAddParcelTextTarget) {
                this.addParcelTextTarget.textContent = "Add another parcel";
            }
            this.updateParcelCount();
            setTimeout(() => this.attachAlternateSelector(chosenParcel), 0);
        }
    }

    setParcelAlternateAddress(e) {
        const form = e.target.closest('form');
        const formData = new FormData(form);

        fetch(form.action, {
            method: form.method,
            body: formData,
            headers: {
                "X-CSRF-Token": document.getElementsByName('csrf-token')[0].content,
                'Accept': 'application/json'
            }
        })
            .then(response => response.text())
            .then(data => {
                console.log('alternate address updated')
                document.querySelector(".selected-parcel").innerHTML = data;
            })
            .catch(error => console.error('Error:', error));

    }

    updateApplicationTypes(e) {
        const form = e.target.closest('form');
        const fieldList = form?.querySelector(".field-scope");
        const templateSelector = document.getElementById("permitting_application_permitting_app_template_id");
        if (!form || !fieldList || !templateSelector) {
            return;
        }
        const currentTemplateId = templateSelector.value;
        const currentTemplateJurisdictionId = templateSelector.options[templateSelector.selectedIndex]?.dataset?.jurisdictionId;
        const selectedParcel = e.currentTarget?.closest?.("li") || e.currentTarget;
        let jurisdictionId = selectedParcel?.dataset?.jurisdictionId;
        if (!jurisdictionId && document.querySelector(".application-parcels")?.querySelector("li") != null) {
            jurisdictionId = document.querySelector(".application-parcels").querySelector("li").dataset.jurisdictionId;
        }
        console.log("updating application types for jurisdiction " + jurisdictionId);
        const formAction = form.action
        const applicationId = formAction.match(/\/(\d+)(?:\/|$)/)?.[1] || "";
        let permitIndustry = undefined;
        if (document.querySelector('input[name="industry"]:checked') != null) {
            permitIndustry = document.querySelector('input[name="industry"]:checked').value
        }
        console.log("updating application type for jurisdiction " + jurisdictionId + " and industry " + permitIndustry);
        const link = 'select_control?jurisdiction_id=' + jurisdictionId + "&application_id=" + applicationId + "&permit_industry=" + permitIndustry
        fetch(link)
            .then(response => {
                return response.text();
            })
            .then(html => {
                document.querySelector(".application-template-selector").innerHTML = html;
                const refreshedTemplateSelector = document.getElementById("permitting_application_permitting_app_template_id");
                if (!refreshedTemplateSelector) {
                    return;
                }
                const jurisdictionChanged = currentTemplateJurisdictionId && jurisdictionId &&
                    currentTemplateJurisdictionId.toString() !== jurisdictionId.toString();
                if (currentTemplateId.length > 0 && !jurisdictionChanged) {
                    refreshedTemplateSelector.value = currentTemplateId;
                }
                validatePermittingForm(form);
            })

    }

    removeParcel(e) {
        let deleteConfirmed = confirm("Are you sure you want to remove this parcel from the application?");
        if (deleteConfirmed) {
            const parcelSummaryArea = document.querySelector(".application-parcels").querySelector("ul");
            const chosenParcel = e.currentTarget.closest('li');
            const parcelId = chosenParcel.dataset.parcelId || chosenParcel.id;
            const assignmentKey = chosenParcel.dataset.assignmentKey;
            chosenParcel.classList.remove('selected');
            e.currentTarget.classList.add('hidden');
            parcelSummaryArea.removeChild(chosenParcel);
            const parcelFieldList = document.querySelector(".selected-parcels")?.querySelector(".results-list");
            if (parcelFieldList) {
                if (assignmentKey) {
                    const assignment = parcelFieldList.querySelector(`li[data-assignment-key="${assignmentKey}"]`);
                    if (assignment) {
                        const destroyField = assignment.querySelector("input[name*='[_destroy]']");
                        const parcelField = assignment.querySelector("input[name*='[parcel_id]']");
                        const alternateField = assignment.querySelector("input[name*='[parcel_alternate_address_id]']");
                        if (parcelField) { parcelField.value = ""; }
                        if (alternateField) { alternateField.value = ""; }
                        if (destroyField) { destroyField.value = 1; }
                    }
                } else {
                    const parcelIdInputs = Array.from(parcelFieldList.querySelectorAll("input[name*='[parcel_id]']"));
                    const targetInput = parcelIdInputs.find(input => {
                        const li = input.closest("li");
                        const liAssignmentKey = li ? li.dataset.assignmentKey : null;
                        return input.value === parcelId && !liAssignmentKey;
                    });
                    if (targetInput) {
                        targetInput.value = "";
                        const targetLi = targetInput.closest("li");
                        const destroyField = targetLi?.querySelector("input[name*='[_destroy]']");
                        const alternateField = targetLi?.querySelector("input[name*='[parcel_alternate_address_id]']");
                        if (alternateField) {
                            alternateField.value = "";
                        }
                        if (destroyField) {
                            destroyField.value = 1;
                        }
                    }
                }
            }
            if (parcelSummaryArea.querySelectorAll("li").length === 0) {
                if (this.hasParcelSearchPanelTarget) {
                    this.parcelSearchPanelTarget.classList.remove("hidden");
                }
                if (this.hasAddParcelTextTarget) {
                    this.addParcelTextTarget.textContent = "Add a parcel";
                }
            }
            this.updateParcelCount();
        }
    }

    currentParcelCount() {
        const parcelSummaryArea = document.querySelector(".application-parcels")?.querySelector("ul");
        return parcelSummaryArea ? parcelSummaryArea.querySelectorAll("li").length : 0;
    }

    updateParcelCount() {
        if (this.hasParcelCountTarget) {
            const count = this.currentParcelCount();
            const label = count === 1 ? "parcel" : "parcels";
            this.parcelCountTarget.textContent = `${count} ${label} selected`;
        }
    }

    removeCase(e) {
        e.target.closest('.deletable').remove;
    }

    removeInspection(e) {
        e.target.parentElement.parentElement.remove();
    }

    setParent(e) {
        e.preventDefault();
        console.log('setting parent');
        window.location.href = window.location.href + '/set_parent?parent_id=' + e.target.closest('.result-permitting-application').id;
    }

    attachAlternateSelectors() {
        const parcelItems = document.querySelectorAll(".application-parcels .result-parcel");
        parcelItems.forEach((item) => this.attachAlternateSelector(item));
    }

    attachAlternateSelector(parcelItem) {
        if (!(parcelItem instanceof HTMLElement)) {
            return;
        }
        const alternateData = this.parseAlternateAddresses(parcelItem.dataset.alternateAddresses);
        const primaryAddress = parcelItem.dataset.primaryAddress;
        const uniqueAlternates = alternateData.filter((alternate) => {
            if (!primaryAddress) {
                return true;
            }
            return alternate.label && alternate.label.toString().toLowerCase() !== primaryAddress.toString().toLowerCase();
        });
        if (uniqueAlternates.length === 0) {
            return;
        }
        const assignmentKey = parcelItem.dataset.assignmentKey;
        const hiddenFields = this.findHiddenFieldsForAssignment(assignmentKey);
        if (!hiddenFields.alternateField) {
            return;
        }
        const selectedValue = hiddenFields.alternateField.value || parcelItem.dataset.selectedAlternateId || "";
        let selectContainer = parcelItem.querySelector(".alternate-address-select");
        if (!selectContainer) {
            selectContainer = document.createElement("div");
            selectContainer.classList.add("alternate-address-select", "mt-1", "text-sm");
            parcelItem.appendChild(selectContainer);
        }
        const select = document.createElement("select");
        select.classList.add("input", "small");
        const defaultOption = document.createElement("option");
        defaultOption.value = "";
        defaultOption.text = "Use primary parcel address";
        select.appendChild(defaultOption);
        uniqueAlternates.forEach((alternate) => {
            const option = document.createElement("option");
            option.value = alternate.id;
            option.text = alternate.label;
            if (selectedValue && selectedValue.toString() === alternate.id.toString()) {
                option.selected = true;
            }
            select.appendChild(option);
        });
        select.addEventListener("change", () => {
            hiddenFields.alternateField.value = select.value;
        });
        selectContainer.innerHTML = "";
        selectContainer.appendChild(select);
        hiddenFields.alternateField.value = select.value || "";
    }

    findHiddenFieldsForAssignment(assignmentKey) {
        const selectedParcels = document.querySelector(".selected-parcels .results-list");
        if (!selectedParcels || !assignmentKey) {
            return {parcelField: null, alternateField: null};
        }
        const li = selectedParcels.querySelector(`li[data-assignment-key="${assignmentKey}"]`);
        if (!li) {
            return {parcelField: null, alternateField: null};
        }
        return {
            parcelField: li.querySelector("input[name*='[parcel_id]']"),
            alternateField: li.querySelector("input[name*='[parcel_alternate_address_id]']")
        };
    }

    parseAlternateAddresses(data) {
        if (!data) {
            return [];
        }
        try {
            const parsed = JSON.parse(data);
            return Array.isArray(parsed) ? parsed : [];
        } catch (error) {
            return [];
        }
    }
}

function validatePermittingForm(form) {
    validateFields(form);
    formSubmittable(form);
    let contactIdPresent = true
    if (document.getElementById("validation-messages").childElementCount > 0) {
        if (form.querySelector("#contact_id") != null) {
            if (form.querySelector("#contact_id").value.length == 0) {
                contactIdPresent = false
            } else {
                contactIdPresent = true
            }
        } else {
            contactIdPresent = true
        }
        Array.from(document.getElementById("validation-messages").children).map(function (element) {
            if (element.innerText.match(/First name.*/)) {
                element.classList.add("hidden");
            } else {
                if (element.innerText.match(/Last name.*/) || !contactIdPresent) {
                    element.innerText = "Payor Needs Selected"
                }
            }
        });
    }
}
